




























// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import apiPersonne from '@/api/personne'
import { toSubArray } from '@/utils/groupBy'
import ReadInformations from '@/components/personne/read/ReadInformations.vue'
import ReadPortail from '@/components/personne/read/ReadPortail.vue'
import { AloPersonne, getDefaultAloPersonne } from '@/models/alo/AloPersonne'
import { PartRestrictFlag } from '@/enum/PartRestrictFlag'


@Component({ 
  name: 'ModifyPersonne', 
  props: {
    personneId:Number 
  },
  components: {ReadInformations, ReadPortail},
})

export default class ModifyPersonne extends Vue {
  personneId!: number
  private showError = false    
  private loading = false
  

  get personne(){
    return this.$store.myGetters.personneDic[this.personneId] || getDefaultAloPersonne()
  }

  loadPersonne() {    
    this.loading = true
    this.$store.myActions.ADM_PERSONNE_DETAIL_REQUEST(this.personneId).finally(() => {
      this.loading = false
    })    
  }

  @Watch('personneId')
  onPersonneIdChanged(){
   this.loadPersonne()
  }

  created(){
    this.loadPersonne()
  }
  
  get arianeItems() { 
    const arianeItems =  [
        {
          text: 'Personnes',
          disabled: false,          
          to: {name:'Personne'},
          exact:true
        }
      ]
    if(this.personne) {
        arianeItems.push({
          text: this.personne.libelle,
          disabled: true,          
          to: {name:''},
          exact:true
        })
    }
    return arianeItems;
  } 

  remove(){
     this.$confirm(`Etes vous sûr de vouloir supprimer la personne '${this.personne.libelle}'`).then((answer)=>{
      if(answer){
        this.$store.myActions.ADM_PERSONNE_DELETE_REQUEST(this.personne.id).then(()=>{
          this.$router.push({name:'Personne'})
        })
      }
    })
  }

}
